<form ngNoForm action="{{ providerURL }}" method="POST">
  <button id="social-button-{{ provider }}" type="submit" class="btn btn-{{ provider }}"
    angulartics2On="click" [angularticsProperties]="('log_in_with_' + provider) | listingTypeAnalyticsTag | async">
  </button>
</form>
